import { render, staticRenderFns } from "./instruction.vue?vue&type=template&id=5cc3cc2a&scoped=true"
import script from "./instruction.vue?vue&type=script&lang=js"
export * from "./instruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc3cc2a",
  null
  
)

export default component.exports